<template>
  <div>
    <CRow>
      <CCol lg="6">
        <CTableWrapper :items="getShuffledUsersData()">
          <template #header>
            <CIcon name="cil-grid" />Simple Table
            <div class="card-header-actions">
              <a
                href="https://coreui.io/vue/docs/components/nav"
                class="card-header-action"
                rel="noreferrer noopener"
                target="_blank"
              >
                <small class="text-muted">docs</small>
              </a>
            </div>
          </template>
        </CTableWrapper>
      </CCol>

      <CCol lg="6">
        <CTableWrapper :items="getShuffledUsersData()" striped caption="Striped Table" />
      </CCol>
    </CRow>

    <CRow>
      <CCol lg="6">
        <CTableWrapper :items="getShuffledUsersData()" small caption="Condensed Table" />
      </CCol>

      <CCol lg="6">
        <CTableWrapper :items="getShuffledUsersData()" fixed bordered caption="Bordered Table" />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <CTableWrapper
          :items="getShuffledUsersData()"
          hover
          striped
          bordered
          small
          fixed
          caption="Combined All Table"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <CTableWrapper
          :items="getShuffledUsersData()"
          hover
          striped
          bordered
          small
          fixed
          dark
          caption="Combined All dark Table"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CTableWrapper from "./Table.vue";

export default {
  data() {
    return {
      usersData: [
        {
          username: "Samppa Nori",
          registered: "2012/01/01",
          role: "Member",
          status: "Active"
        },
        {
          username: "Estavan Lykos",
          registered: "2012/02/01",
          role: "Staff",
          status: "Banned"
        },
        {
          username: "Chetan Mohamed",
          registered: "2012/02/01",
          role: "Admin",
          status: "Inactive"
        },
        {
          username: "Derick Maximinus",
          registered: "2012/03/01",
          role: "Member",
          status: "Pending"
        },
        {
          username: "Friderik Dávid",
          registered: "2012/01/21",
          role: "Staff",
          status: "Active"
        },
        {
          username: "Yiorgos Avraamu",
          registered: "2012/01/01",
          role: "Member",
          status: "Active"
        },
        {
          username: "Avram Tarasios",
          registered: "2012/02/01",
          role: "Staff",
          status: "Banned",
          _classes: "table-success"
        },
        {
          username: "Quintin Ed",
          registered: "2012/02/01",
          role: "Admin",
          status: "Inactive"
        },
        {
          username: "Enéas Kwadwo",
          registered: "2012/03/01",
          role: "Member",
          status: "Pending"
        },
        {
          username: "Agapetus Tadeáš",
          registered: "2012/01/21",
          role: "Staff",
          status: "Active"
        },
        {
          username: "Carwyn Fachtna",
          registered: "2012/01/01",
          role: "Member",
          status: "Active",
          _classes: "table-success"
        },
        {
          username: "Nehemiah Tatius",
          registered: "2012/02/01",
          role: "Staff",
          status: "Banned"
        },
        {
          username: "Ebbe Gemariah",
          registered: "2012/02/01",
          role: "Admin",
          status: "Inactive"
        },
        {
          username: "Eustorgios Amulius",
          registered: "2012/03/01",
          role: "Member",
          status: "Pending"
        },
        {
          username: "Leopold Gáspár",
          registered: "2012/01/21",
          role: "Staff",
          status: "Active"
        },
        {
          username: "Pompeius René",
          registered: "2012/01/01",
          role: "Member",
          status: "Active"
        },
        {
          username: "Paĉjo Jadon",
          registered: "2012/02/01",
          role: "Staff",
          status: "Banned"
        },
        {
          username: "Micheal Mercurius",
          registered: "2012/02/01",
          role: "Admin",
          status: "Inactive"
        },
        {
          username: "Ganesha Dubhghall",
          registered: "2012/03/01",
          role: "Member",
          status: "Pending"
        },
        {
          username: "Hiroto Šimun",
          registered: "2012/01/21",
          role: "Staff",
          status: "Active"
        },
        {
          username: "Vishnu Serghei",
          registered: "2012/01/01",
          role: "Member",
          status: "Active"
        },
        {
          username: "Zbyněk Phoibos",
          registered: "2012/02/01",
          role: "Staff",
          status: "Banned"
        },
        {
          username: "Einar Randall",
          registered: "2012/02/01",
          role: "Admin",
          status: "Inactive",
          _classes: "table-danger"
        },
        {
          username: "Félix Troels",
          registered: "2012/03/21",
          role: "Staff",
          status: "Active"
        },
        {
          username: "Aulus Agmundr",
          registered: "2012/01/01",
          role: "Member",
          status: "Pending"
        }
      ]
    };
  },
  name: "Tables",
  components: { CTableWrapper },
  methods: {
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },

    getShuffledUsersData() {
      return this.shuffleArray(this.usersData.slice(0));
    }
  }
};
</script>
